module.exports = __webpack_public_path__ + "img/asset_mSOL-USDC.9d067ad3.png";